(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hero = document.querySelector('[data-lf-hero]');
  if (hero && !reduce) {
    var ticking = false;
    var update = function () {
      var r = hero.getBoundingClientRect();
      var p = Math.min(Math.max(-r.top / (r.height || 1), 0), 1);
      hero.style.setProperty('--lf-p', p.toFixed(3));
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }
  var els = document.querySelectorAll('.lf-reveal');
  if (reduce || !('IntersectionObserver' in window)) {
    els.forEach(function (e) { e.classList.add('is-in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    });
  }, { threshold: 0.15 });
  els.forEach(function (e) { io.observe(e); });
})();

(function () {
  var loader = document.querySelector('[data-lf-loader]');
  if (loader) {
    var seen = false;
    try { seen = sessionStorage.getItem('lf-seen') === '1'; sessionStorage.setItem('lf-seen', '1'); } catch (e) {}
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (seen || reduce) { loader.remove(); }
    else {
      loader.classList.add('is-on');
      window.setTimeout(function () { loader.classList.add('is-out'); }, 2000);
      window.setTimeout(function () { loader.remove(); }, 2600);
    }
  }
  document.querySelectorAll('[data-lf-track]').forEach(function (track) {
    var root = track.closest('section');
    var step = function () { return Math.max(track.clientWidth * 0.8, 240); };
    var prev = root.querySelector('[data-lf-prev]'), next = root.querySelector('[data-lf-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });
})();

(function () {
  var desktop = window.matchMedia('(min-width: 750px)').matches;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('video[data-lf-src]').forEach(function (v) {
    if (!desktop || reduce) { v.remove(); return; }
    v.src = v.getAttribute('data-lf-src');
    v.addEventListener('playing', function () { v.classList.add('is-playing'); });
    var p = v.play();
    if (p && p.catch) { p.catch(function () { v.remove(); }); }
  });
})();
